import * as React from 'react';
// import CreateActivityForm from '../Components/Activity/CreateActivityForm';
import queryString from 'query-string';
import { RouteComponentProps } from 'react-router-dom';
import { UserInfoContext } from '../Main';
import AppConfig from '../Constants';
import CreateOfficeSpace from '../Components/OfficeSpace/CreateOfficeSpace';
import EditOfficeSpace from '../Components/OfficeSpace/EditOfficeSpace';
// import EditActivityForm from '../Components/Activity/EditActivityForm';

interface IPlanOfficeSpaceState{
    isViewForm:boolean;
    isNewForm:boolean;
    itemId:string; 
    ParentId:string;
    CloneTime:number;
}
interface IPlanOfficeSpaceProps{
    handleRedirection:(selectedKey:any)=>void;
}
export class PlanOfficeSpace extends React.Component<RouteComponentProps & IPlanOfficeSpaceProps,IPlanOfficeSpaceState> {
    constructor(props:RouteComponentProps & IPlanOfficeSpaceProps) {
        super(props);
        this.state ={
            isViewForm:false,
            isNewForm:true,
            ParentId: "0",
            CloneTime: 0,
            itemId:'0'
        };
        this.props.handleRedirection('3');        
    }    
    componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        if(values){
            var keyValue:string = '0';
            let _pidValue: string = "0";
            let _CloneTimeParam: number = 0;
            var keyViewFlagValue:boolean = false;   
            for (const key in values) {
                if(key.toUpperCase() === AppConfig.ActivityForm.IdParam.toUpperCase()){
                    keyValue = values[key] as string;
                }  
                if(key.toUpperCase() === AppConfig.ActivityForm.ViewParam.toUpperCase()){
                    var keyVal = values[key]as string;
                    keyViewFlagValue = parseInt(keyVal)==1?true:false;
                }
                if(key.toUpperCase() === AppConfig.ActivityForm.ParentIdParam.toUpperCase()){
                    _pidValue = values[key] as string;                                        
                }   
                if(key.toUpperCase() === AppConfig.ActivityForm.CloneTimeParam.toUpperCase()){
                    _CloneTimeParam = parseInt(values[key] as string) ;                                        
                }     
            }
            if(keyValue!=='0'){
                this.setState({
                    isNewForm:false,
                    isViewForm:keyViewFlagValue,
                    itemId:keyValue,
                    ParentId:_pidValue, 
                    CloneTime:_CloneTimeParam
                });  
            }                    
        }

    }
    render() {
        const {isNewForm, isViewForm, ParentId, CloneTime, itemId} = this.state;
        return (
            <div style={{width:"90%", margin: "0.5em auto"}}>                
               {isNewForm? <CreateOfficeSpace />:
               <><EditOfficeSpace Id={parseInt(itemId)} office={true} ParentId={+ParentId} CloneTime={CloneTime} viewForm={isViewForm}/></>}
            </div>
        );
    }
}
